import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

import { createQueryClient } from '@/lib/query/query-client';

/**
 * Fournit le client TanStack Query à l'arbre React.
 *
 * Le client est créé dans un `useState` initialisé paresseusement, et non au
 * niveau module : cela garantit une instance par montage (donc un cache isolé
 * par test) et évite qu'un rechargement à chaud n'en recrée un à chaque rendu.
 */
export const QueryProvider = ({ children }: { children: ReactNode }) => {
  const [queryClient] = useState(createQueryClient);

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
